import axios from "axios";
import { Testimonial } from "../interfaces/testimonial.interface";

class TestimonialsApi {

  getTestimonials(): Promise<Testimonial[]> {
    const apiUrl = "/api/v1/testimonials";

    return axios.get(apiUrl)
    .then(response => {
      const testimonials = response.data.data.map(responseData => {
        const testimonialData = responseData.attributes;
        const testimonial:Testimonial = {
          id: testimonialData.id,
          title: testimonialData.title,
          author: testimonialData.author,
          comment: testimonialData.body,
        }
        return testimonial;
      })
      return Promise.resolve(testimonials);
    });
  }

}

export default TestimonialsApi;